import { HelpTooltip } from '@app/components/various/HelpTooltip';
import { cn } from '@app/utils/cn';
import { isDefined } from '@app/utils/is';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

interface Props {
  as?: 'label' | 'span' | 'div';
  label: string;
  id?: string;
  isRequired?: boolean;
  helpMessage?: React.ReactNode;
  size?: 'medium' | 'large';
  orientation?: 'vertical' | 'horizontal';
  className?: string;
}

export const FieldLabel = (props: React.WithOptionalChildren<Props>) => {
  const {
    as: As = 'label',
    label,
    id,
    children,
    isRequired = true,
    orientation = 'vertical',
    helpMessage,
    size = 'large',
    className,
  } = props;
  const { t } = useTranslation(['common']);

  const styledLabel = <span className={cx({ 'body-1': size === 'large', 'body-4': size === 'medium' })}>{label}</span>;

  return (
    <As
      className={cn(
        'flex gap-x-8 gap-y-1',
        {
          'flex-col': orientation === 'vertical',
          'items-center': orientation === 'horizontal',
        },
        className,
      )}
    >
      <span id={id} className="flex justify-between">
        {!isDefined(helpMessage) ?
          styledLabel
        : <span className="flex items-center gap-1">
            {styledLabel}
            <HelpTooltip content={helpMessage} />
          </span>
        }
        {!isRequired && (
          <span className="text-neutral-60 body-5" aria-hidden="true">
            {t('common:optional')}
          </span>
        )}
      </span>
      {children}
    </As>
  );
};
